import { Typography } from "antd"
import Select from 'react-select'
import React, { useState } from 'react'

import { usePet } from '../../modules'

import Modal from "../resusable/modal"
import Confirm from "../resusable/confirm"
// import Amenities from './amenities'

const { Paragraph } = Typography

const NewPrinter = ({ toggle, visible, onComplete }) => {
    const [name, setName] = useState()
    const [ip, setIp] = useState()

    const [{ loading }, execute] = usePet('newPrinter', {
        name,
        ipAddress: ip
    }, { notify: true, hasFile: true, callback: (_, notif, ops) => {
        notif('Printer has been added', ops('success'))
        onComplete()
        setTimeout(toggle, 300)
    }, manual: true, load: { msg: 'Adding new printer...' } })

    return (
        <Modal
            h="h-auto"
            w="w-1/2 lg:w-1/3 xl:w-1/4"
            title="New Printer"
            toggle={toggle}
            visible={visible}>
            <div className="w-full bg-white">
                <div className="flex flex-wrap -mx-3 mb-3">
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Printer Name
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-name"
                            type="text"
                            name="name"
                            value={name}
                            onChange={ e => setName(e.target.value) }
                            placeholder="Kitchen" />
                    </div>
                </div>  
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Printer IP Address
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-ip"
                            type="text"
                            name="ip"
                            value={ip}
                            onChange={ e => setIp(e.target.value) }
                            placeholder="192.X.X.X" />
                    </div>
                </div> 
            </div>
            <div className="flex justify-end">
                <button onClick={ () => Confirm({
                    title: 'Save Changes?',
                    desc: 'Are you sure you want to save these changes?',
                    okText: 'Save Changes',
                    onOk: execute
                }) } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default NewPrinter